module.exports = __webpack_public_path__ + "img/icon_4_33.96e7f071.png";